export default "__VITE_ASSET__DIHTThAZ__"